import { Card, Typography, Link } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';

/**
 * Arrears card
 * @param {*} param0
 * @returns
 */
function ArrearsCard({
    id,
    backgroundColor,
    textColor,
    paragraphOne,
    paragraphTwo,
    paragraphThree,
    paragraphFour,
    paragraphFive,
    tel,
    balance
}) {
    return (
        <Card
            id={id}
            sx={{
                backgroundColor: `${backgroundColor}`,
                color: `${textColor}`,
                borderRadius: 0,
            }}
        >
            <span
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography
                    sx={{
                        fontWeight: "bold",
                        fontSize: 20,
                        ml: 2,
                        pt: 1.2,
                        flexGrow: 1,
                    }}
                >
                    Your current arrears balance:<Typography display="inline" sx={{
                        fontWeight: "bold",
                        fontSize: 20,
                        color: "secondary.main"
                    }}> {balance} </Typography>
                    <CircleIcon sx={{ color: "secondary.main", fontSize: "18px", verticalAlign: "top" }} />
                </Typography>
            </span>
            <Typography
                sx={{
                    fontSize: 16,
                    mt: 1.5,
                    mx: 2,
                }}
            >
                {paragraphOne}
                <Typography display="inline" sx={{
                    fontWeight: "bold",
                    fontSize: 16
                }}> {balance}</Typography>
                . {paragraphTwo}
            </Typography>
            <Typography
                sx={{
                    fontSize: 16,
                    mt: 1.5,
                    mx: 2,
                }}
            >
                {paragraphThree} {paragraphFour} <Link sx={{ color: "secondary.main" }} href={`tel:${tel}`}>{tel}</Link>.
            </Typography>
            <Typography
                sx={{
                    fontSize: 16,
                    mt: 1.5,
                    mx: 2,
                    mb: 5,
                }}
            >
                <b>Important:</b> {paragraphFive}
            </Typography>
        </Card>)
}

export default ArrearsCard;